import { useTheme } from '@automata/mui-theme';
import { ScaleBand } from 'd3-scale';
import { useId } from 'react';

export type Props = {
  width: number;
  scaleY: ScaleBand<string>;
  domainY: string[];
};

const ZebaStripes = ({ width, scaleY, domainY }: Props): JSX.Element => {
  const id = useId();
  const theme = useTheme();

  return (
    <g id={`zebra-stripes-${id}`}>
      {domainY.map((id, i) => (
        <rect
          key={id}
          x={0}
          y={scaleY(id)}
          width={Math.max(width, 0)}
          height={Math.max(scaleY.bandwidth(), 0)}
          fill={i % 2 !== 0 ? theme.palette.grey[200] : 'white'}
        />
      ))}
    </g>
  );
};

export default ZebaStripes;
